export { default } from './icon'
export type { Icons, Props as IconProps } from './icon'
